var cycleItemCount;
var cycleItemIndex = 1;
var prevButton, nextButton;
var galleryModal,galleryModalImage,galleryModalCaption,galleryModalClose,mainWrapper;

var mapLocRefs = Array();

function filterHandler(){
    var filter;
    //if the url contains tagged
    if (window.location.href.indexOf("tagged") > -1) {
        //set filter equal to the last segment of the url
        filter = window.location.href.split('/').pop();
    } else {
        filter = 'all';
    }

    //get the filter button with the data-val attribute that matches the filter variable
    var filterButton = document.querySelector('.filter[data-val="{0}"]'.f(filter));
    //add the active class to the filter button
    filterButton.classList.add('active');
};


//generic string.format function
String.prototype.format = String.prototype.f = function () {
    var s = this,
        i = arguments.length;

    while (i--) {
        s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
    }
    return s;
};

function formCheckboxHandler(){
    //attach a click event to all .form-input-checkbox elemets in .contact form
    document.querySelectorAll('.contact .form-input-checkbox').forEach(function (checkbox) {
        checkbox.addEventListener('click', function () {
            //if the checkbox has .all-products-cb class
            if (checkbox.classList.contains('all-products-cb')) {
                //uncheck all other checkboxes
                document.querySelectorAll('.contact .form-input-checkbox:not(.all-products-cb) input').forEach(function (checkbox) {
                    checkbox.checked = false;
                    //remove .cb-selected class from this checkbox
                    checkbox.parentElement.classList.remove('cb-selected');
                });
                //add "cb-selected" class to the parent .form-input-checkbox.all-products-cb
                document.querySelector('.contact .form-input-checkbox.all-products-cb').classList.add('cb-selected');
            }
            else{
                //uncheck the all-products-cb checkbox
                document.querySelector('.contact .form-input-checkbox.all-products-cb input').checked = false;
                //remove cb-selected from .all-products-cb
                document.querySelector('.contact .form-input-checkbox.all-products-cb').classList.remove('cb-selected');
                //add "cb-selected" class to this element
                checkbox.classList.add('cb-selected');
            }
            //if no checkboxes are check, check the all-products-cb checkbox
            if (document.querySelectorAll('.contact .form-input-checkbox input:checked').length == 0) {
                //remove .cb-selected from all elements that have it
                document.querySelectorAll('.contact .form-input-checkbox.cb-selected').forEach(function (checkbox) {
                    checkbox.classList.remove('cb-selected');
                });
                document.querySelector('.contact .form-input-checkbox.all-products-cb input').checked = true;
                document.querySelector('.contact .form-input-checkbox.all-products-cb').classList.add('cb-selected');
            }
        });
    });
};

function setDefaultChecks(){
    //check the checkboxes that have a parent with .cb-selected
    document.querySelectorAll('.contact .form-input-checkbox.cb-selected input').forEach(function (checkbox) {
        checkbox.checked = true;
    });
};

function nextButtonHandler(){
    cycleItemIndex++;

    if(cycleItemIndex == cycleItemCount){
        //add the .not-active class to the next button
        nextButton.classList.add('not-active');
    }
    else if(cycleItemIndex > cycleItemCount){
        cycleItemIndex = cycleItemCount;
    }   
    else{

        //remove the .not-active class the prevButton if it exists
        if(prevButton.classList.contains('not-active')){
            prevButton.classList.remove('not-active');
        }
    }
}

function prevButtonHandler(){
    cycleItemIndex--;

    //add the not-active class if we're at the beginning
    if(cycleItemIndex == 1){
        //add the .not-active class to the prev button
        prevButton.classList.add('not-active');
    }
    //set the cycleItemIndex to 1 if less than 1 to stay in range
    else if(cycleItemIndex < 1){
        cycleItemIndex = 1;
    }
    else{
        //remove the .not-active class from the nextButton if it exists
        if(nextButton.classList.contains('not-active')){
            nextButton.classList.remove('not-active');
        }
    }
}

function buttonTrackInitializer(context){

    var theSelector;
    var prevBtnSelector = '.prev-next-buttons .prev-next-button--prev';
    var nextBtnSelector = '.prev-next-buttons .prev-next-button--next';

    switch(context){
        case 'timeline':
            theSelector = '.timeline__item';
            break;
        case 'native-carousel':
            theSelector = '.text-with-icons__item';
            break;
        default:
            console.log('no context specified');
            return;
    }
    //set cycleItemCount equal to the number of timeline__item
    cycleItemCount = document.querySelectorAll(theSelector).length;

    prevButton = document.querySelector(prevBtnSelector);
    nextButton = document.querySelector(nextBtnSelector);
    
    prevButton.addEventListener('click', prevButtonHandler);

    nextButton.addEventListener('click', nextButtonHandler);
};

function blogButtonTrackInitializer(){
    try{
    var currentPage = Number(document.querySelector('[aria-current="page"]').innerHTML);
        if(currentPage == 1){
            //add not-active class to prev button
        }
        else{

        }
        console.log(currentPage);
    }catch(e){

    }
};

function showModal(){
    //add the .show class to galleryModal
    galleryModal.classList.add('show');
    //disable scrolling
    document.body.classList.add('no-scroll');
    mainWrapper.classList.add('darken');
    // document.body.classList.add('not-active');
};

function hideModal(){
    //remove the .show class from galleryModal
    galleryModal.classList.remove('show');
    //enable scrolling
    document.body.classList.remove('no-scroll');
    mainWrapper.classList.remove('darken');
    // document.body.classList.remove('not-active');
    galleryModalImage.src = '#';
};


//==========================================================
//galleryModalNextHandler/galleryModalPrevHandler pseudocode
//==========================================================

//get the gallery-item with .currently-in-modal class
//get the next gallery-item
//if there is a next gallery-item
    //remove the .currently-in-modal class from the current gallery-item
    //add the .currently-in-modal class to the next
    //set the src of the galleryModalImage to the src of the next gallery-item
//else get the first gallery-item
    //remove the .currently-in-modal class from the current gallery-item
    //add the .currently-in-modal class to the first gallery-item
    //set the src of the galleryModalImage to the src of the first gallery-item

function galleryModalNextHandler(){
    
    var currentGalleryItem = document.querySelector('.gallery__item.currently-in-modal');
    
    var nextGalleryItem = currentGalleryItem.nextElementSibling;
    
    if(nextGalleryItem){
        
        currentGalleryItem.classList.remove('currently-in-modal');
        
        nextGalleryItem.classList.add('currently-in-modal');
        
        galleryModalImage.src = nextGalleryItem.querySelector('img').src;

        try{

            galleryModalCaption.innerHTML = nextGalleryItem.querySelector('figcaption p').innerHTML;
        }catch(e){
            galleryModalCaption.innerHTML = '';
        }
    }
    
    else{
        
        currentGalleryItem.classList.remove('currently-in-modal');
        
        document.querySelector('.gallery__item').classList.add('currently-in-modal');
        
        galleryModalImage.src = document.querySelector('.gallery__item').querySelector('img').src;

        try{
            galleryModalCaption.innerHTML = document.querySelector('.gallery__item').querySelector('figcaption p').innerHTML;
            galleryModalCaption.style.display="block";
        }catch(e){
            galleryModalCaption.innerHTML = '';
        }
    }
}

function galleryModalPrevHandler(){
    var currentGalleryItem = document.querySelector('.gallery__item.currently-in-modal');

    var prevGalleryItem = currentGalleryItem.previousElementSibling;

    if(prevGalleryItem){

        currentGalleryItem.classList.remove('currently-in-modal');
        
        prevGalleryItem.classList.add('currently-in-modal');
        
        galleryModalImage.src = prevGalleryItem.querySelector('img').src;

        try{
            galleryModalCaption.innerHTML = prevGalleryItem.querySelector('figcaption p').innerHTML;
        }catch(e){
            galleryModalCaption.innerHTML = '';
        }
    }
    
    else{
        
        currentGalleryItem.classList.remove('currently-in-modal');
        
        document.querySelector('gallery-list .gallery__item:last-child').classList.add('currently-in-modal');
        
        galleryModalImage.src = document.querySelector('gallery-list .gallery__item:last-child').querySelector('img').src;

        try{
            galleryModalCaption.innerHTML = document.querySelector('gallery-list .gallery__item:last-child').querySelector('figcaption p').innerHTML;
            galleryModalCaption.style.display="block";
        }catch(e){
            galleryModalCaption.innerHTML = '';            
        }
    }
};

function initGoogleMap(){

    const locations = [
        { lat: 43.749527, lng: -87.71252799999999 },
        { lat: 43.8236621, lng: -88.1664523 },
        { lat: 43.9206703, lng: -88.3068454 },
        { lat: 44.0133439, lng: -88.184288  },
        { lat: 43.0229238, lng: -87.9103993 }
    ];

    const content = [
        "<div class='gm-overlay' id='ol-1'>(1) Stefano's Slo Food Market</div>",
        "<div class='gm-overlay' id='ol-2'>(2) Salchert Meats</div>",
        "<div class='gm-overlay' id='ol-3'>(3) LaClare Family Creamery</div>",
        "<div class='gm-overlay' id='ol-4'>(4) Calanna Specialty Farm Store</div>",
        "<div class='gm-overlay' id='ol-5'>(5) La Merenda</div>",
    ];

    const center = { lat: 43.751535, lng: -87.785789 };

    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 8,
        center: center,
    });

    for(let i = 0; i < locations.length; i++){
        const infowindow = new google.maps.InfoWindow({
            content: content[i],
            ariaLabel: i
        });
        const marker = new google.maps.Marker({
            position: locations[i],
            map: map
        });
        marker.addListener("click", () => {
            infowindow.open({
                anchor: marker,
                map
            });
        });

        mapLocRefs.push(infowindow);
    }

    console.log(mapLocRefs);

    document.querySelectorAll('.shopify-section--image-with-text-block .image-with-text-block__content p').forEach(function(el){

        if(el.querySelector('strong')){
            el.addEventListener('click', function(){
                //get the closest <strong> element
                //get the text of the closest <strong> element
                //if the text is 1
                    //open the infowindow with id ol-1
                //else if the text is 2
                    //open the infowindow with id ol-2
                //else if the text is 3
                    //open the infowindow with id ol-3
                //else if the text is 4
                    //open the infowindow with id ol-4
                //else if the text is 5
                    //open the infowindow with id ol-5

                var clickedStore = this.querySelector('strong');

                //get the text of clickedStore and remove everything except the number
                var storeNumber = clickedStore.innerText.replace(/[^0-9]/g, '');

                var storeId = 'ol-'+storeNumber;

                for(var i = 0; i < mapLocRefs.length; i++){
                    //if the content property of mapLocRefs[i] contains the storeId then show it
                    if(mapLocRefs[i].content.includes(storeId)){
                        console.log(mapLocRefs[i].content, ' { INCLUDES ', storeId, ' }');
                        infowindow.open(map, mapLocRefs[i]);
                    }
                    //otherwise close it
                    else{
                        console.log(mapLocRefs[i].content, ' { MISSING ', storeId, ' }');
                        mapLocRefs[i].close();
                    }
                }
            });
        }
    });
    document.querySelector('.shopify-section--image-with-text-block .image-with-text-block__content').addEventListener('click', function(){
        //scroll to #map
        document.querySelector('#map').scrollIntoView({behavior: 'smooth'});
    });
};

 window.onload = function(){ 

    document.querySelector('.footer__image').addEventListener('click', function(){
        window.location = '/';
    });

    //if #map exists
    if(document.querySelector('#map')){
        initGoogleMap();
    }
    
    if (document.querySelector('.filter-container')) {
        filterHandler();
    }

    if(document.querySelector('.contact form .form-input-checkbox')){
        setDefaultChecks();
        formCheckboxHandler();
    }

    if (document.querySelector('native-carousel')) {
        buttonTrackInitializer('native-carousel');
    }

    if (document.querySelector('.timeline')) {
        buttonTrackInitializer('timeline');
    }

    if (document.querySelector('.shopify-section--main-blog')) {
        blogButtonTrackInitializer();
    }

    //if gallery-list exists
    if(document.querySelector('gallery-list')){
        
        //get all gallery-item elements
        var galleryItems = document.querySelectorAll('gallery-item');
        mainWrapper = document.querySelector('#main');
        
        //add click event listener to each gallery-item
        galleryItems.forEach(function (galleryItem) {
            galleryItem.addEventListener('click', function(){
                console.log('gallery item clicked');
                //get the src of the clicked image
                var clickedImageSrc = this.querySelector('img').src;
                var clickedImageCaption = this.querySelector('figcaption p');
                var captionText = clickedImageCaption === null ? '' : clickedImageCaption.innerHTML;
                
                //set the src of the gallery-modal__image to the clicked image src
                galleryModalImage.src = clickedImageSrc;
                galleryModalCaption.innerHTML = captionText;

                if(captionText.length === 0){
                    //hide figcaption
                    galleryModalCaption.style.display = 'none';
                }

                //add .currently-in-modal class to the clicked gallery-item
                this.classList.add('currently-in-modal');
                
                //show the modal
                showModal();
            });
        });
    }

    //if #myModal exists
    if(document.querySelector('#myModal')){
        //get the modal
        galleryModal = document.querySelector('#myModal');
        
        //get galleryModalImage
        galleryModalImage = document.querySelector('#myModal img');

        galleryModalCaption = document.querySelector('#myModal figcaption p');

        //get the close button
        galleryModalClose = document.querySelector('#myModal .close-modal-button');

        //add a click event to galleryModalClose
        galleryModalClose.addEventListener('click', hideModal);

        //get .prev-next-button--prev
        var galleryModalPrev = document.querySelector('#myModal .prev-next-button--prev');
        //get .prev-next-button--next
        var galleryModalNext = document.querySelector('#myModal .prev-next-button--next');

        //add click event to galleryModalPrev
        galleryModalPrev.addEventListener('click', galleryModalPrevHandler);
        //add click event to galleryModalNext
        galleryModalNext.addEventListener('click', galleryModalNextHandler);
    }

    //if shopify-section--contact-form exists
    if (document.querySelector('.shopify-section--contact-form')) {
        //if .shopify-section--faq exists
        if (document.querySelector('.shopify-section--faq')) {
            //get the .shopify-section--faq element
            var faqSection = document.querySelector('.shopify-section--faq');
            //copy the faqSection var
            var faqSectionCopy = faqSection.cloneNode(true);
            //set the display of faq to none
            faqSection.style.display = 'none';
            //get the aside element
            var aside = document.querySelector('aside');
            //append the faq element to the aside element
            aside.appendChild(faqSectionCopy);
        }

        //if image-with-text[reveal-on-scroll] exists
        if (document.querySelector('.image-with-text[reveal-on-scroll]')) {
            //get the image-with-text[reveal-on-scroll] element
            var imageWithText = document.querySelector('.image-with-text[reveal-on-scroll]');
            //copy the image-with-text[reveal-on-scroll] element
            var imageWithTextCopy = imageWithText.cloneNode(true);
            //get the .shopify-section--contact-form .contact element
            var contact = document.querySelector('.shopify-section--contact-form .contact');
            //append the image-with-text[reveal-on-scroll] element to the .shopify-section--contact-form .contact element
            contact.appendChild(imageWithTextCopy);
            //set the display of image-with-text[reveal-on-scroll] to none
            imageWithText.style.display = 'none';
            
            //if .shopify-section--promotion-blocks exists and there is more than one, grab the last one
            if (document.querySelectorAll('.shopify-section--promotion-blocks').length > 1) {
                var promotionBlocks = document.querySelectorAll('.shopify-section--promotion-blocks');
                var lastPromotionBlock = promotionBlocks[promotionBlocks.length - 1];
                //copy the last promotion block
                var lastPromotionBlockCopy = lastPromotionBlock.cloneNode(true);
                lastPromotionBlockCopy.classList.add('promotion-blocks-custom');
                //replace lastPromotionBlock with lastPromotionBlockCopy
                lastPromotionBlock.parentNode.replaceChild(lastPromotionBlockCopy, lastPromotionBlock);
                //remove lastPromotionBlock
                lastPromotionBlock.remove();
                
                //create an element with class flexxy-col
                var flexxyCol = document.createElement('div');
                flexxyCol.classList.add('flexxy-col');
                //wrap imageWithTextCopy and lastPromotionBlockCopy in flexxyCol
                imageWithTextCopy.parentNode.insertBefore(flexxyCol, imageWithTextCopy.nextSibling);
                flexxyCol.appendChild(imageWithTextCopy);
                flexxyCol.appendChild(lastPromotionBlockCopy);
                
            }

            //get image-with-text__content-wrapper from imageWithTextCopy and remove it
                //remove it here so we can still reference it
            imageWithTextCopy.querySelector('.image-with-text__content-wrapper').remove();
        }
    }
}